// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__2yO5A","content":"styles_content__3KYHX"};